import React, { Component } from 'react';
import HTML5Backend from 'react-dnd-html5-backend';
import PropTypes from 'prop-types';
import { DragDropContext } from 'react-dnd';
import TouchBackend from 'react-dnd-touch-backend';
import MediaQuery from 'react-responsive';
import * as classnames from 'classnames';

import './App.css';

import GalleryContainer from './components/gallery-container/GalleryContainer';
import EditorWrapper from './components/editor-wrapper/EditorWrapper';
import LayoutContainer from './components/layout-container/LayoutContainer';
import PagePreviewContainer from './components/page-preview-container/PagePreviewContainer';
import TopBarContainer from './components/top-bar/top-bar-container/TopBarContainer';
import TextTools from './components/text-tools/TextTools';
import {
  hideComponent,
  browserNotSupported } from './redux/helpers';
import SavebookLoader from './components/savebook-loader/savebookLoader';
import TurnBackDevice from './components/turn-back-device/TurnBackDevice';

function isTouchDevice() {
    const hasTouchEvents = 'ontouchstart' in window;
    const hasTouchPoints =
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
        (navigator.msMaxTouchPoints && navigator.msMaxTouchPoints > 0);
    console.log('isTouchDevice', hasTouchEvents, hasTouchPoints);

    // Csak akkor számítson touch device-nak, ha tényleg elérhető touch input
    return hasTouchEvents && hasTouchPoints;
}

//function setDndBackend() {
//  return isTouchDevice() ? TouchBackend : HTML5Backend;
//}

function setDndBackend() {
    if (isTouchDevice()) {
        //return TouchBackend({ enableMouseEvents: true });
        return TouchBackend;
    }
    return HTML5Backend;
}
class App extends Component {
  constructor(args) {
    super(...args);
    this.state = {
      hideComponent: false,
    };
  }

  componentWillMount() {
    if (hideComponent()) {
      this.setState({
        hideComponent: true,
      });
    }
  }

  componentDidMount() {
    window.addEventListener('load', this.setInnerWidthHeightVariable);
    window.addEventListener('resize', this.setInnerWidthHeightVariable);
    this.disableIosMultitouch();
  }

  disableIosMultitouch = () => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
      window.document.addEventListener('touchmove', e => {
        if(e.scale !== 1) {
          e.preventDefault();
        }
      }, {passive: false});
    }
  }

  isSamsungBrowser = () => {
    return navigator.userAgent.match(/SamsungBrowser/i) ? true : false;
  }

  setInnerWidthHeightVariable = () => {
      console.log('setInnerWidthHeightVariable');
    let innerHeight = window.innerHeight;
    let innerWidth = window.innerWidth;

    document.documentElement.style.setProperty('--innerHeight', `${innerHeight}px`);
    document.documentElement.style.setProperty('--innerWidth', `${innerWidth}px`);
  }

  render() {
    const { lang } = this.props;

    if (browserNotSupported()) {
      return (
        <div className="unsopported">
          <p>{lang.browserNotSupported}</p>
        </div>
      );
    }

    return (
      <div className="BookDesigner">
        <div className="Topbar">
          <TopBarContainer lang={lang} />
        </div>
        <div className="BookDesigner_ContentColumn">
          <div className="BookDesignerTopBar">
            <PagePreviewContainer lang={lang} />
          </div>

          <div className="BookDesigner_MiddleWrapper">
            <div className={`BookDesigner_LeftColumn ${this.state.hideComponent ? 'hide' : ''} `}>
              <GalleryContainer lang={lang} />
            </div>
            <div className={classnames(
              `BookDesigner_MiddleColumn`,
              `${this.state.hideComponent ? 'hide' : ''}`)
            }>
              <EditorWrapper lang={lang} />
              <div className="textTools">
                <TextTools
                  lang={lang}
                />
              </div>
              <div className="BookDesigner_BottomBar">
                <LayoutContainer lang={lang} />
              </div>
            </div>
          </div>
        </div>
        <div className="BookDesigner_RightColumn" />
        <SavebookLoader lang={lang} />
        <MediaQuery maxWidth={991} orientation='landscape'>
            <TurnBackDevice lang={lang} />
        </MediaQuery>
      </div>
    );
  }
}

App.defaultProps = {
  lang: {},
};

App.propTypes = {
  lang: PropTypes.object,
};

export default DragDropContext(setDndBackend())(App);


// WEBPACK FOOTER //
// ./src/App.jsx